var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAddTrailing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00016 1.3335C4.32416 1.3335 1.3335 4.32416 1.3335 8.00016C1.3335 11.6762 4.32416 14.6668 8.00016 14.6668C11.6762 14.6668 14.6668 11.6762 14.6668 8.00016C14.6668 4.32416 11.6762 1.3335 8.00016 1.3335ZM8.00016 2.66683C10.9408 2.66683 13.3335 5.0595 13.3335 8.00016C13.3335 10.9408 10.9408 13.3335 8.00016 13.3335C5.0595 13.3335 2.66683 10.9408 2.66683 8.00016C2.66683 5.0595 5.0595 2.66683 8.00016 2.66683ZM7.3335 5.3335V7.3335H5.3335V8.66683H7.3335V10.6668H8.66683V8.66683H10.6668V7.3335H8.66683V5.3335H7.3335Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddTrailing);
export default __webpack_public_path__ + "static/media/add_trailing.334ba239796edf68c2e350817b871056.svg";
export { ForwardRef as ReactComponent };